import React from "react";
import { FaArrowLeft, FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const BackBtn = ({ onClick, className = "" }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="flex items-center justify-center gap-2 ">
      <FaArrowLeft onClick={handleClick} className={className} />
      {/* BACK */}
    </div>
  );
};

export default BackBtn;
